/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const putOrganization = /* GraphQL */ `
  mutation PutOrganization($name: String!, $description: String) {
    putOrganization(name: $name, description: $description) {
      name
      description
      alias
    }
  }
`;

export const putCustomerGroup = /* GraphQL */ `
  mutation putCustomerGroup($name: String!, $description: String) {
    putCustomerGroup(name: $name, description: $description) {
      name
      description
      alias
    }
  }
`;
export const putUser = /* GraphQL */ `
  mutation PutUser($company: String!, $email: String!, $name: String!, $phone: String!, $role: Role!, $sftp: Boolean!, $surname: String!) {
    putUser(company: $company, email: $email, name: $name, phone: $phone, role: $role, sftp: $sftp, surname: $surname) {
      surname
      role
      phone
      name
      email
      company
      active
      id
    }
  }
`;
export const linkFolder = /* GraphQL */ `
  mutation LinkFolder($username: String!, $path: String!) {
    linkFolder(username: $username, path: $path) {
      path
      username
    }
  }
`;
export const removeLinkFolder = /* GraphQL */ `
  mutation removeLinkFolder($username: String!, $path: String!) {
    removeLinkFolder(username: $username, path: $path) {
      path
      username
    }
  }
`;
export const deleteFolderProvider = /* GraphQL */ `
  mutation deleteFolderProvider($path: [String]!) {
    deleteFolderProvider(path: $path) {
      path
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation deleteUser($username: String!) {
    deleteUser(username: $username) {
      username
    }
  }
`;
export const deleteGroup = /* GraphQL */ `
  mutation deleteGroup($groupName: String!) {
    deleteGroup(groupName: $groupName)
  }
`;
export const disableUser = /* GraphQL */ `
  mutation disableUser($username: String!) {
    disableUser(username: $username) {
      username
    }
  }
`;
export const enableUser = /* GraphQL */ `
  mutation enableUser($username: String!) {
    enableUser(username: $username) {
      username
    }
  }
`;
export const resetPassword = /* GraphQL */ `
  mutation resetPassword($username: String!) {
    resetPassword(username: $username)
  }
`;
export const lockFile = /* GraphQL */ `
  mutation lockFile($filePath: String!) {
    lockFile(filePath: $filePath)
  }
`;
export const unlockFile = /* GraphQL */ `
  mutation unlockFile($filePath: String!) {
    unlockFile(filePath: $filePath)
  }
`;
export const confirmFile = /* GraphQL */ `
  mutation confirmFile($filePath: String!) {
    confirmFile(filePath: $filePath)
  }
`;
export const makeDeliverableExchange = /* GraphQL */ `
  mutation makeDeliverableExchange($sourcePrefix: String!, $targetPrefix: String!) {
    makeDeliverableExchange(sourcePrefix: $sourcePrefix, targetPrefix: $targetPrefix) {
      sourceBucket
      sourcePrefix
      targetBucket
      targetPrefix
    }
  }
`;
export const makeDeliverableCustomer = /* GraphQL */ `
  mutation makeDeliverableCustomer($sourcePrefix: String!, $targetPrefix: String!, $groupName: String!) {
    makeDeliverableCustomer(sourcePrefix: $sourcePrefix, targetPrefix: $targetPrefix, groupName:$groupName) {
      sourceBucket
      sourcePrefix
      targetBucket
      targetPrefix
    }
  }
`;
export const putSftpCustomer = /* GraphQL */ `
  mutation putSftpCustomer($id: String!, $email: String!, $role: Role!, $name: String, $surname: String, $phone: String, $company: String!) {
    putSftpCustomer(id: $id, email: $email, name: $name, surname: $surname, phone: $phone, role: $role, company: $company) {
      email
      role
      name
      surname
      phone
      company
      active
      id
    }
  }
`;
export const deleteSftpCustomer = /* GraphQL */ `
  mutation deleteSftpCustomer($id: String!, $username: String!) {
    deleteSftpCustomer(id: $id, username: $username) {
      username
    }
  }
`;